<!--
 * @Author: your name
 * @Date: 2021-10-11 13:32:54
 * @LastEditTime: 2021-10-11 14:55:06
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/arkHome/components/chatType.vue
-->
<!--  -->
<template>
    <div>
      <div class="cover">
        <div class="box">
          <img
            @click="hidePanel"
            class="close"
            src="@/assets/img/loginImg/closeb.png"
            alt=""
          />
          <p>
            阅读并同意<router-link to="/registeredapp">《用户协议》</router-link>、<a href="https://mobile.iqihang.com/zt/privacy_app/index.html">《隐私政策》</a>
          </p>
          <p>方可继续完成登录</p>
          <div class="btnBox">
            <button
              id="customBtn"
              class="chat zhiCustomBtn"
              @click="hidePanel()"
            >
              取消
            </button>
            <button
              class="chat"
              @click="receivePraive()"
            >同意</button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  
  export default {
    components: {},
    data() {
      return {};
    },
    computed: {
      ...mapState(['userInfo']),
    },
    watch: {},
    methods: {
      hidePanel() {
        this.$emit('close', false);
      },
      receivePraive() {
        this.$emit('receivePraive', true);
        this.$emit('validationCode');
        this.$emit('close', false);
        this.$emit('checked')
      },
    },
    created() { },
    mounted() { },
  };
  </script>
  <style lang="scss" scoped>
  .cover {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 5000;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    .box {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 608px;
      height: 380px;
      padding-top: 100px;
      background: #fff;
      border-radius: 20px;
      transform: translate(-50%, -50%);
      .close {
        position: absolute;
        top: 30px;
        right: 30px;
        z-index: 100;
        width: 28px;
      }
      p {
        margin-bottom: 30px;
        padding: 0 20px;
        color: #333;
        font-weight: 500;
        font-size: 30px;
        text-align: center;
        a {
          color: #ff6c02;
        }
      }
      div {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;
        margin-top: 60px;
        padding: 0 25px;
        button {
          width: 255px;
          height: 75px;
          color: #fff;
          font-size: 28px;
          line-height: 68px;
          text-align: center;
          background: #ff6c02;
          border-radius: 50px;
        }
        button:nth-child(1) {
          color: #000;
          background-color: #fff;
          border: 2px solid #D1D1D1;
        }
      }
    }
  }
  </style>
  